<template>
  <v-expansion-panel-header
    color="primary"
    class="white--text elevation-5 rounded-0 no-shadow-below"
  >
    <template v-slot:actions>
      <v-icon color="white"> $expand </v-icon>
    </template>
    <slot></slot>
  </v-expansion-panel-header>
</template>

<script>
// @ is an alias to /src
export default {
  name: "ResumationExpansionPanelHeader",
  data: () => ({}),
  props: {},
  components: {},
  methods: {},
  mounted() {},
  computed: {}
};
</script>

<style scoped>
.no-shadow-below {
  z-index: 1;
}
</style>
